






































import { Component, Vue } from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import CalendarPanel from '@/components/calendar/CalendarPanel.vue';
import { Inject } from 'vue-typedi';
import { StoreService } from '@/services/StoreService';
import { Zone } from '@/model/Zone';
import dayjs from 'dayjs';
import { CalendarRange } from '@/model/calendar/CalendarRange';
import ConfirmDialog from '@/components/dialog-box/ConfirmDialog.vue';
import { Store } from '@/model/Store';
import { Closure } from '@/model/Closure';

@Component({
    components: { GlobalHeader, CalendarPanel, ConfirmDialog }
})
export default class ClosuresBody extends Vue {

    @Inject()
    storeService!: StoreService;

    private static readonly DAYJS_DATE_FORMAT_BACK: string = "YYYY-MM-DD";
    private static readonly DAYJS_DATE_FORMAT_FRONT: string = "DD/MM/YYYY";

    store: Store = null;
    selectedZone: Zone = null;
    dates: CalendarRange[] = [];
    hasError: boolean = false;

    isDialogOpen: boolean = false;
    popUpText: string = null;

    selectedRange: CalendarRange = null;
    rangeOpening: CalendarRange = null;
    rangesOverlapping: CalendarRange[] = [];
    
    created() {
        this.storeService.getStoreById().then(store => this.store = store);
    }

    confirmSelection(selectedRange: CalendarRange){
        this.resetRanges();
        this.selectedRange = selectedRange;
        if (this.isSelectedRangeInsideRange(this.dates, this.selectedRange)) {
            this.setDialogInformationOpeningRange();
            return;
        }
        this.setDialogInformationClosingRange();  
        
    }

    setDialogInformationClosingRange() {
        this.popUpText = `Fermeture du ${this.formatDateToString(this.selectedRange.startDate, ClosuresBody.DAYJS_DATE_FORMAT_FRONT)} au ${this.formatDateToString(this.selectedRange.endDate, ClosuresBody.DAYJS_DATE_FORMAT_FRONT)}\n`;
        this.rangesOverlapping = this.dates.filter(x => (x.endDate >= this.selectedRange.startDate || this.isOneDayClose(x.endDate, this.selectedRange.startDate)) 
                                                    && (x.startDate <= this.selectedRange.endDate || this.isOneDayClose(x.startDate, this.selectedRange.endDate)));
        if (this.rangesOverlapping.length > 0) {
            this.popUpText += `Les fermetures suivantes vont être fusionnées avec la nouvelle :`
            this.rangesOverlapping.forEach(x => this.popUpText += `\nDu ${this.formatDateToString(x.startDate, ClosuresBody.DAYJS_DATE_FORMAT_FRONT)} au ${this.formatDateToString(x.endDate, ClosuresBody.DAYJS_DATE_FORMAT_FRONT)}`)  
        } 
        this.isDialogOpen = true;
    }   

    setDialogInformationOpeningRange() {
        this.rangeOpening = this.findCalendarRangeContainsSelectedRange(this.dates, this.selectedRange);
        this.popUpText = `Suppression de la fermeture du ${this.formatDateToString(this.selectedRange.startDate, ClosuresBody.DAYJS_DATE_FORMAT_FRONT)} au ${this.formatDateToString(this.selectedRange.endDate, ClosuresBody.DAYJS_DATE_FORMAT_FRONT)}\n`;
        this.isDialogOpen = true;
    }

    saveClosuresChanges(){
        this.selectedZone.closures = [];
        this.dates.forEach(element => 
            this.selectedZone.closures.push(this.calendarRangeToClosure(element))
        );
        this.storeService.updateClosures(this.store, this.selectedZone)
            .then(store => {
                this.store = store
                this.hasError = false;
            })
            .catch(error => this.hasError = true);
    }

    confirmEventDialog(){
        this.closeDialog();
        if(this.rangeOpening !== null){
            return this.openRangeOperation();
        }

        return this.overlapRangeOperation();
    }

    closeDialog() {
        this.isDialogOpen = false;
    }

    addDateToRanges(newDate: CalendarRange) {
        this.dates.push(newDate);
    }

    resetRanges(){
        this.rangeOpening = null;
        this.rangesOverlapping = [];
    }

    changeZone(){
        this.hasError = false;
        this.dates = [];
        this.selectedZone.closures.forEach(element => {
            this.dates.push(this.closureToCalendarRange(element));
        });
    }

    openRangeOperation() {
        this.dates = this.dates.filter(x => x != this.rangeOpening);
        if (!this.isSameDate(this.selectedRange.startDate, this.rangeOpening.startDate)) {
            this.addDateToRanges({ startDate: this.rangeOpening.startDate, endDate: dayjs(this.selectedRange.startDate).subtract(1, 'day').toDate() });
        }
        if (!this.isSameDate(this.selectedRange.endDate, this.rangeOpening.endDate)) {
            this.addDateToRanges({ startDate: dayjs(this.selectedRange.endDate).add(1, 'day').toDate(), endDate: this.rangeOpening.endDate });
        }
        this.saveClosuresChanges();
    }

    overlapRangeOperation() {
        const rangesOverlapping: CalendarRange[] = this.dates.filter(x => x.endDate >= this.selectedRange.startDate 
                                                                    && x.startDate <= this.selectedRange.endDate)
            .concat(this.findOneDayCloseRanges(this.dates, this.selectedRange));
        rangesOverlapping.push(this.selectedRange);
        this.selectedRange.startDate = rangesOverlapping.reduce((prev, curr) => prev.startDate < curr.startDate ? prev : curr).startDate;
        this.selectedRange.endDate = rangesOverlapping.reduce((prev, curr) => prev.endDate > curr.endDate ? prev : curr).endDate;
        this.dates = this.dates.filter(x => !rangesOverlapping.includes(x));
        this.addDateToRanges(this.selectedRange);
        this.saveClosuresChanges();
    }

    closureToCalendarRange(calendarClosure: Closure): CalendarRange{
        const calendarRange = new CalendarRange();
        calendarRange.startDate = dayjs(calendarClosure.startDate, ClosuresBody.DAYJS_DATE_FORMAT_BACK).toDate();
        calendarRange.endDate = dayjs(calendarClosure.endDate, ClosuresBody.DAYJS_DATE_FORMAT_BACK).toDate();
        return calendarRange;
    }

    calendarRangeToClosure(calendarRange: CalendarRange): Closure{
        const calendarClosureRange = new Closure();
        calendarClosureRange.startDate = dayjs(calendarRange.startDate).format(ClosuresBody.DAYJS_DATE_FORMAT_BACK);
        calendarClosureRange.endDate = dayjs(calendarRange.endDate).format(ClosuresBody.DAYJS_DATE_FORMAT_BACK);
        return calendarClosureRange;
    }

    isSelectedRangeInsideRange(datesRanges : CalendarRange[], rangeToFind: CalendarRange){
        return datesRanges.some(x => dayjs(x.endDate).isSameOrAfter(dayjs(rangeToFind.endDate)) 
                                    && !dayjs(x.startDate).isAfter(dayjs(rangeToFind.startDate)));
    }

    findCalendarRangeContainsSelectedRange(datesRanges : CalendarRange[], rangeToFind: CalendarRange): CalendarRange{
        return datesRanges.find(x => dayjs(x.endDate).isSameOrAfter(dayjs(rangeToFind.endDate)) 
                                    && !dayjs(x.startDate).isAfter(dayjs(rangeToFind.startDate)));
    }

    findOneDayCloseRanges(datesRanges : CalendarRange[], rangeToFind: CalendarRange): CalendarRange[]{
        return datesRanges.filter(x => this.isOneDayClose(x.startDate, rangeToFind.endDate) 
                                    || this.isOneDayClose(x.endDate, rangeToFind.startDate));
    }

    isSameDate(date1: Date, date2: Date) {
        return (dayjs(date1).isSame(dayjs(date2), 'day'));
    }

    isOneDayClose(date1: Date, date2: Date) {
        return (dayjs(date1).isSame(dayjs(date2).add(1, 'day'), 'day') || dayjs(date1).isSame(dayjs(date2).subtract(1, 'day'), 'day'));
    }

    formatDateToString(date: Date, format: string) {
        return dayjs(date).format(format);
    }

}
